import { service } from '../../../../helpers/http'

export const ActionGetActivityOffereds = ({ dispatch }, payload) => {

    return service({
        module: 'domainActivityOffered',
        action: 'getActivityOffereds',
        payload: payload
    })

}

export const ActionPostActivityOffered = ({ dispatch }, payload) => {

    return service({
        module: 'domainActivityOffered',
        action: 'postActivityOffered',
        payload: payload
    })

}

export const ActionPutActivityOffered = ({ dispatch }, payload) => {

    return service({
        module: 'domainActivityOffered',
        action: 'putActivityOffered',
        payload: payload
    })

}

export const ActionDeleteActivityOffered = ({ dispatch }, payload) => {

    return service({
        module: 'domainActivityOffered',
        action: 'deleteActivityOffered',
        payload: payload
    })

}

export const ActionDeleteActivityOfferedTimeTable = ({ dispatch }, payload) => {

    return service({
        module: 'domainActivityOffered',
        action: 'deleteActivityOfferedTimeTable',
        payload: payload
    })

}

export const ActionDeleteActivityOfferedTeacher = ({ dispatch }, payload) => {

    return service({
        module: 'domainActivityOffered',
        action: 'deleteActivityOfferedTeacher',
        payload: payload
    })

}

export const ActionDeleteActivityOfferedTeacherInscription = ({ dispatch }, payload) => {

    return service({
        module: 'domainActivityOffered',
        action: 'deleteActivityOfferedTeacherInscription',
        payload: payload
    })

}
